import { render, staticRenderFns } from "./BankAccountTable.vue?vue&type=template&id=d95458f0"
import script from "./BankAccountTable.vue?vue&type=script&lang=js"
export * from "./BankAccountTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports